class HomeSections {
    constructor() {

        if (this.checkUrlHome()) {
            this.numberDiv()
            this.numberSection()
            // this.replaceIconsSvg()
            this.hiddenSubtitleGallery()
            this.countSeconds()
            this.bannerSwiperHome()
        } else {
            this.viewAndHiddenText()
        }
    }

    checkUrlHome() {
        let pathname = false
        if ((window.location.pathname==='/en-ww') || (window.location.pathname.length === 1)) {
          pathname = true;
        }else{
          pathname = false;
        }
        // const pathname = window.location.pathname.length === 1
        return pathname
    }

    numberDiv() {
        const divs = document.querySelectorAll('div.shopify-section')
        let url_local = 'http://127.0.0.1:9292/',
            url_dev = 'https://estrafalario-dev.myshopify.com/',
            url_prod = '',
            num_section = 0

        divs.forEach($element => {
            $element.classList.add(`shopify-div-${num_section++}`)
        })
    }

    numberSection() {
        const sections = document.querySelectorAll('section.shopify-section')
        let num_section = 0

        sections.forEach($element => {
            $element.classList.add(`shopify-section-${num_section++}`)
            console.log('demo')
        })
    }

    replaceIconsSvg() {
        let icon_tree = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 214.99 214.99"><defs><style>.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:2.5px;}.cls-2{stroke-width:8px;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Diseño">' +
                            '<path class="cls-1" d="M99.5,165.66a70.48,70.48,0,0,0-3-31.45c-.68-2-1.66-4.26-3.66-5.05a6.76,6.76,0,0,0-4.73.37c-4,1.49-7.51,4.07-11.44,5.75s-9.68,2.55-13.24-.63-5.63-8.9-6.63-13.45c-2.06-9.41-2.27-25,6.3-31.64,2.14-1.65,5-1.68,7.61-1.58,2.35.1,4.85-.13,7.13.12,4.77.53,9,5,9.77,9.62a2.66,2.66,0,0,1-.6,2.57,2.41,2.41,0,0,1-1,.4A8.45,8.45,0,0,1,79.43,99,16.68,16.68,0,0,1,75,93.63c-4.2-7.44-4.57-15.22-.6-22.92a9.07,9.07,0,0,1,4.29-4.49c2.26-.92,4.86-.3,7.24-.82,6.23-1.37,8.23-9.32,13.21-13.3,8.9-7.13,21.68.42,29.15,6.17a46.82,46.82,0,0,1,15,20.95c2.72,7.33,5.94,18.67-.22,25.16-3.85,4-11.14,3.84-16.2,3.36a5.38,5.38,0,0,1-2.17-.53,3.91,3.91,0,0,1-1.76-2.57c-.73-3-.1-7.22,1.92-9.65,2.2-2.63,7.17-2.92,8.67.17.55,1.13.57,2.52,1.38,3.47a4.53,4.53,0,0,0,2.38,1.26c5.74,1.51,13.28,1.25,18,5.41,7.61,6.73,3.38,21.8-3.09,27.94a18,18,0,0,1-11.1,4.66,25.53,25.53,0,0,1-11.95-2.26,17.42,17.42,0,0,1-6.24-4.22c-1.1-1.24-2-2.75-3.43-3.55-6.35-3.53-7.9,7-8.4,10.65a49.9,49.9,0,0,0,1.28,19.87,16.71,16.71,0,0,0,3.76,7.4"/><circle class="cls-2" cx="107.49" cy="107.49" r="103.49"/></g></g>' +
                        '</svg>'
        let icon_clothing = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 214.99 214.99"><defs><style>.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:2.5px;}.cls-2{stroke-width:8px;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Diseño">' +
                                '<path class="cls-1" d="M111.67,51.08h33.66a6,6,0,0,1,6,6V157.88a6,6,0,0,1-6,6H113.92a6,6,0,0,1-6-6l.25-73.62a5,5,0,0,1,3.91-4.89c7.74-1.73,8.14-5.56,9.56-9.4a3.37,3.37,0,0,1,3.08-2.2c3-.1,6.6-.29,7.64-.2,1.35.12,6,3.44,10.81,25.67.61,1.59-.13,4-4.79,5.16s-9.83,1.22-10,4.66-.25,17.81,1.47,22.6,4.3,14.37,4.55,18.79c-.37,3.32-3,4.54-11.67,4.42s-14.37,0-14.37,0-6.63-.13-15.35,0-11.3-1.1-11.67-4.42c.25-4.42,2.83-14,4.55-18.79s1.59-19.16,1.47-22.6-5.28-3.56-10-4.66-5.4-3.57-4.79-5.16C77.44,71,82.11,67.67,83.46,67.55a41.63,41.63,0,0,1,5.12.1c1.65.07,4.43-.39,5.59,1.1.63.81.54,1.94.62,3a8.56,8.56,0,0,0,3.13,5.88,9.26,9.26,0,0,0,6.39,2c4.74-.3,3.6-9.71,3.6-9.71s0-5.22,0-7.83V57.1a6,6,0,0,0-6-6H69.66a6,6,0,0,0-6,6V157.88a6,6,0,0,0,6,6h32.28"/><circle class="cls-2" cx="107.49" cy="107.49" r="103.49"/></g></g>' +
                            '</svg>'
        let icon_inabif = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 214.99 214.99"><defs><style>.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:2.5px;}.cls-2{stroke-width:8px;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Diseño"><path class="cls-1" d="M151.24,131.19c11.72-2.28,21.07-13.43,21.26-25.36a5.74,5.74,0,0,0-.91-3.76,5.37,5.37,0,0,0-3.51-1.64c-3.44-.49-6.93.24-10.41.27s-7.31-.84-9.36-3.65c-1.89-2.59-1.78-6.06-2-9.25-.32-5.73-1.71-16.82-7.62-19.52-4-1.81-9.21-1-12.23-4.22-2.36-2.47-2.49-6.61-5.14-8.76-2-1.59-4.7-1.64-7.22-1.6a40.37,40.37,0,0,0-8.58.71A34.77,34.77,0,0,0,87.5,65.81c-2.89,3.55-4.86,7.75-7.64,11.29-5.29,6.74-3,16.31-3.24,24.23a5.28,5.28,0,0,1-.83,3.18c-1,1.22-2.8,1.3-4.37,1.29-.65,0-1.45-.13-1.66-.74a1.05,1.05,0,0,1,.54-1.16,2.56,2.56,0,0,1,1.34-.26c2.42,0,4.72.81,7.1,1.08,2.65.31,4-.71,6.31-1.35a.55.55,0,0,1,.31,0c.15,0,.21.22.24.37.08.39.15.79.24,1.19a15.32,15.32,0,0,1,.32,2,9.61,9.61,0,0,1-.49,4.22c-1.45,3.87-3.63,4.83-2.9,6s2.77,1.88,4,2.25a10.16,10.16,0,0,0,3.1.4c.77,0,2.09,0,2.56-.68a1.28,1.28,0,0,0,0-1.26.63.63,0,0,0-.33-.31.88.88,0,0,0-.28,0c-2.36.16-4,3-5.13,4.8a17.55,17.55,0,0,0-2.59,7.68,3.86,3.86,0,0,0,.26,2.16,3.91,3.91,0,0,0,2.73,1.65,16.81,16.81,0,0,0,14.89-4,1.74,1.74,0,0,0,.74-1.38c-4.49,1.44-10-4.07-13.8-1.3-1.29.94-2.59.46-4,.15a3,3,0,0,0-1.07-.11,3.09,3.09,0,0,0-1.79,1.33A15,15,0,0,0,80,131.81c-1.82,4.16,3.88,11,6.34,14A8.78,8.78,0,0,0,88.6,148a7.34,7.34,0,0,0,5.3.5,62,62,0,0,0,16.75-6.36c5.41-3.07,9.26-7.4,12.91-12.38A29.92,29.92,0,0,0,129,115.09c.23-2.19.27-4.48,1.35-6.39a3,3,0,0,1,.88-1,2.57,2.57,0,0,1,3.15.53,5.84,5.84,0,0,1,1.35,3.13,10.1,10.1,0,0,1-.44,5.74c-1.73,4-6,3.42-8.87,1-3.55-3.11-5.78-9.18-6.8-13.64-1.08-4.76.31-10-2.25-14.41-2.42-4.18-7-5.82-11.62-6.11-5.65-.36-10.19,1.26-15.48,2.75a43.1,43.1,0,0,1-14.75,1.3c-5.67-.46-6.57-6.21-3.46-10.36a39.21,39.21,0,0,1,5.51-5.26c2-1.85,4.27-4.38,4.29-7.3a3,3,0,0,0-1.29-2.63,3.92,3.92,0,0,0-1.79-.44c-6.32-.34-9.76,3.28-13.4,7.79-2.91,3.61-5.72,7.31-8.57,11-3.93,5-7.88,10.09-10.68,15.81S41.74,108.7,42.83,115A11.29,11.29,0,0,0,46,121.55c4.46,4,11.61,1.46,17.41,3a5.45,5.45,0,0,1,3.28,2.09,5.9,5.9,0,0,1,.7,3.1c.08,7.08-3.76,13.72-4,20.8-.1,2.57.4,5.4,2.35,7.09a10,10,0,0,0,3.93,1.81,51.44,51.44,0,0,0,12.14,1.82"/><circle class="cls-2" cx="107.49" cy="107.49" r="103.49"/></g></g></svg>'

        const media = document.querySelectorAll('.multicolumn .multicolumn-list .multicolumn-card .media')
        const img = document.querySelectorAll('.multicolumn .multicolumn-list .multicolumn-card .media img')
        const svgArray = [icon_tree, icon_clothing, icon_inabif]

        img.forEach($element => {
            $element.remove()
        })

        for (var index = 0; index < media.length; index++) {
            media[index].insertAdjacentHTML('beforeend', svgArray[index]);
        }
    }

    hiddenSubtitleGallery() {
        const subtitle = document.querySelector('.shopify-div-3 .enrm-branding')
        if (subtitle) {
            subtitle.setAttribute("style", "")
        }
    }

    countSeconds() {
        
        const cards = document.querySelectorAll('.shopify-section-4 .multicolumn-list .multicolumn-list__item .multicolumn-card .multicolumn-card__info h3')

        // window.onscroll = function(ev) {
        //     console.log(window.scrollY)
        //     var element = document.querySelector('.shopify-section-4')
        //     if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight) {
        //       // you're at the bottom of the page
        //       console.log("Bottom of page");
        //     }
        //     if (element.offsetHeight + element.scrollTop === element.scrollHeight) {
        //         console.log('llego')
        //     }
        // };

        if (cards[0]) {
            for (var index = 0; index < cards.length; index++) {
                var n = 0,
                    card_0 = cards[0],
                    x = cards[0].innerHTML

                window.setInterval(function(){
                    card_0.innerHTML = n;
                    if(n != x){
                        n++;
                    }
                },80);
            }
        }

        if (cards[1]) {
            for (var index_1 = 0; index_1 < cards.length; index_1++) {
                var n_1 = 0,
                    card_1 = cards[1],
                    x_1 = cards[1].innerHTML

                window.setInterval(function(){
                    card_1.innerHTML = n_1;
                    if(n_1 != x_1){
                        n_1++;
                    }
                },80);
            }
        }

        if (cards[2]) {
            for (var index_2 = 0; index_2 < cards.length; index_2++) {
                var n_2 = 0,
                    card_2 = cards[2],
                    x_2 = cards[2].innerHTML

                window.setInterval(function(){
                    card_2.innerHTML = n_2;
                    if(n_2 != x_2){
                        n_2++;
                    }
                },80);
            }
        }
    }

    bannerSwiperHome() {
        const slider = document.querySelector('.js-slider')
        
        if (slider) {
            console.log(slider)
            const loop = slider.getAttribute('data-autorotate') === 'true'
            const delay = slider.getAttribute('data-speed')
        
            const mySwiper = new Swiper('.js-slider', {
            loop,
            autoplay: {
                delay,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            })
        }
    }

    viewAndHiddenText() {
        const   box_text = document.querySelector('.shopify-section .rich-text .rich-text__blocks .rich-text__text.rte'),
                box_text_all = document.querySelectorAll('.template-01 .shopify-section .subtitle'),
                url_all = document.querySelectorAll('.template-01 .shopify-section .subtitle__url'),
                btnHtml = '<a role="link" href="javascript:void(0);" aria-disabled="true" class="rich-text_subtitle button--primary toogleBtn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.36 15.33" class="icon-arrow"><g id="Capa_2" data-name="Capa 2"><g id="Diseño"><path d="M36.36,7.63l-5.17,7.7H28L32,9H0V6.29H32L28,0h3.24Z"/></g></g></svg> Leer más</a>'
        
        // add a(href)
        if (box_text) {
            if (box_text.offsetHeight > 200) {
                box_text.insertAdjacentHTML('afterend', btnHtml)
            }
        }

        // add a(href)
        if (box_text_all) {
            for (var index = 0; index < url_all.length; index++) {
                if (box_text_all[index].offsetHeight >= 270) {
                    url_all[index].insertAdjacentHTML('beforeend', btnHtml)
                }
            }

            var toggleAccordion = function() {
                const thisItem = this.previousSibling.previousSibling
    
                box_text_all.forEach(item => {
                    if (thisItem == item) {
                        thisItem.classList.add('open')
                        thisItem.nextElementSibling.remove()
                        return;
                    }
                });
            }

            url_all.forEach(question => question.addEventListener('click', toggleAccordion));
        }

        var btn = document.querySelector('.shopify-section .rich-text .rich-text__blocks a.rich-text_subtitle.toogleBtn')
        
        if (btn) {
            btn.addEventListener('click', (event) => {
                if (btn.innerText == 'Leer más' || btn.innerText == ' Leer más' || btn.innerText == 'leer más' || btn.innerText == ' leer más') {
                    box_text.classList.add('open');
                    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.36 15.33" class="icon-arrow"><g id="Capa_2" data-name="Capa 2"><g id="Diseno"><path d="M0,7.7,5.17,0H8.41l-4,6.32h32V9h-32l4,6.29H5.17Z"/></g></g></svg> Leer menos'
                } else {
                    box_text.classList.remove('open');
                    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.36 15.33" class="icon-arrow"><g id="Capa_2" data-name="Capa 2"><g id="Diseño"><path d="M36.36,7.63l-5.17,7.7H28L32,9H0V6.29H32L28,0h3.24Z"/></g></g></svg> Leer más'
                }
            })
        }
    }
}  